import { create } from 'zustand'

import {
  getPurchaseOrders,
  getItemsPurchaseOrders,
  editItemPurchaseOrderObservation,
  reversePurchaseOrder,
  transferPurchaseOrder
} from './provider'

import type { OcNfModalProps } from './types'

export const useOcNfModal = create<OcNfModalProps>((set) => ({
  purchaseOrdersData: null,
  setPurchaseOrdersData: (data) => set({ purchaseOrdersData: data }),

  isPurchaseOrdersLoading: false,
  setIsPurchaseOrdersLoading: (value) => set({ isPurchaseOrdersLoading: value }),

  itemsPurchaseOrdersData: null,
  setItemsPurchaseOrdersData: (data) => set({ itemsPurchaseOrdersData: data }),

  isItemsPurchaseOrdersLoading: false,
  setIsItemsPurchaseOrdersLoading: (value) => set({ isItemsPurchaseOrdersLoading: value }),

  isEditItemPurchaseOrderObservationLoading: false,
  setIsEditItemPurchaseOrderObservationLoading: (value) => set({ isEditItemPurchaseOrderObservationLoading: value }),

  isReversePurchaseOrderLoading: false,
  setIsReversePurchaseOrderLoading: (value) => set({ isReversePurchaseOrderLoading: value }),

  isTransferPurchaseOrderLoading: false,
  setIsTransferPurchaseOrderLoading: (value) => set({ isTransferPurchaseOrderLoading: value }),

  getPurchaseOrders,
  getItemsPurchaseOrders,
  editItemPurchaseOrderObservation,
  reversePurchaseOrder,
  transferPurchaseOrder
}))
